/**
 * 原生散标产品详情页
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import { compare } from './version'
import newView from './newView'
import { call, uriSuishouji } from './bridge'

/**
 * productId: 产品id
 * url: 对应产品的H5地址
 */
export default (productId, url) => {
  if (useragent.isSuishouji) {
    const featureVersion = useragent.isAndroid ? '10.2.4.5' : '10.4.5'
    if (compare(featureVersion)) {
      call(uriSuishouji('requestOpenProfitProduct', { productId }))
    } else if (url) {
      newView(url)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestOpenProfitProduct.js